import { Col, Row, Typography } from "antd";
import ComingSoon from "./../../assets/svgs/ComingSoon.svg";
import "./comingSoon.css";
const ComingSoonComponent = () => {
  return (
    <>
      <Row style={{ width: "100%" }}>
        <Col span={24} className="coming-soon-container">
          <Typography className="coming-soon-heading">Coming Soon</Typography>
          <img src={ComingSoon} />
          <Typography className="coming-soon-para">
            We are working in this feature and this will available for you soon.
          </Typography>
        </Col>
      </Row>
    </>
  );
};
export default ComingSoonComponent;
